import { render, staticRenderFns } from "./EditarSim.vue?vue&type=template&id=0f077829&"
import script from "./EditarSim.vue?vue&type=script&lang=ts&"
export * from "./EditarSim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports